import { Pipe, PipeTransform } from '@angular/core';
interface RenewalStatusResult {
  status: string;
  className: string;
}

@Pipe({
  name: 'stringToDateAndRenewal',
  // standalone: true,
})
export class StringToDateAndRenewalPipe implements PipeTransform {
  transform(dateString: string | undefined): RenewalStatusResult {
    let result: RenewalStatusResult = {
      status: '',
      className: '',
    };

    if (!dateString) {
      result.status = 'Not Available';
      result.className = 'not-available';
      return result;
    }

    const expiryDate = new Date(dateString);
    const today = new Date();
    const expiryDateTime = expiryDate.getTime();
    const todayTime = today.getTime();
    const sixtyDaysInMillis = 60 * 24 * 60 * 60 * 1000; // 60 days in milliseconds

    if (expiryDateTime - todayTime <= 0) {
      result.status = 'Expired';
      result.className = 'renewal-expired';
    } else if (expiryDateTime - todayTime <= sixtyDaysInMillis) {
      result.status = 'Renewal Required';
      result.className = 'renewal-required';
    } else {
      result.status = 'Active';
      result.className = 'renawal-active';
    }

    return result;
  }

  // transform(dateString: string | undefined): string {
  //   if (!dateString) {
  //     return 'Not Available';
  //   }

  //   const expiryDate = new Date(dateString);
  //   const today = new Date();
  //   const expiryDateTime = expiryDate.getTime();
  //   const todayTime = today.getTime();
  //   const sixtyDaysInMillis = 60 * 24 * 60 * 60 * 1000; // 60 days in milliseconds

  //   if (expiryDateTime - todayTime <= 0) {
  //     return 'Expired';
  //   } else if (expiryDateTime - todayTime <= sixtyDaysInMillis) {
  //     return 'Renewal Required';
  //   } else {
  //     return 'Active';
  //   }
  // }
}
